// removed by extract-text-webpack-plugin
module.exports = {"root":"ItemStats--root--f2","item":"ItemStats--item--NR","name":"ItemStats--name--2-","valueCell":"ItemStats--valueCell--ud","bar":"ItemStats--bar--3i","numerical":"ItemStats--numerical--3E","barFill":"ItemStats--barFill--3y","value":"ItemStats--value--2Z"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ItemStats/styles.styl
// module id = 840
// module chunks = 0